import {
  Button,
  Divider,
  Flex,
  HStack,
  Icon,
  Select,
  Tbody,
  Td,
  Thead,
  Tr,
  VStack,
  useColorModeValue,
  Table,
  Th,
  Tooltip,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader
} from '@chakra-ui/react';
import Card from 'components/Card/Card';
import { useEffect, useState } from 'react';
import ResultsController from './controllers/ResultsController';
import { FaInfoCircle, FaEye, FaEdit } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';

function ResultsView() {
  const [data, setData] = useState([]);
  const [audits, setAudits] = useState([]);
  const [lotes, setLotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedAudit, setSelectedAudit] = useState({ id: '', name: '' });
  const [selectedLote, setSelectedLote] = useState('');
  const history = useHistory();

  const [editResponse, setEditResponse] = useState(null);
  const [newAnswer, setNewAnswer] = useState('');
  const [isEditing, setIsEditing] = useState(false);

  const jwtToken = localStorage.getItem("access_token");

  const textColor = useColorModeValue("gray.700", "white");

  const fetchData = async (auditName, lote) => {
    try {
      const response = await ResultsController.listResults(jwtToken, auditName, lote);
      if (!response) {
        throw new Error('Network response was not ok');
      }
      setData(response);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  async function fetchAudits() {
    const response = await ResultsController.listaudits(jwtToken);
    if (!response) {
      console.error("Failed to list");
      return;
    }
    setAudits(response);
  }

  async function fetchLotes(auditId) {
    const response = await ResultsController.listLotes(jwtToken, auditId);
    if (!response) {
      console.error("Failed to list lotes");
      return;
    }
    setLotes(response);
  }

  const handleRefinarResultado = async (auditName, questionName, lote) => {
    setLoading(true);
    try {
      const response = await ResultsController.refinarResult(jwtToken, auditName, questionName, lote);
      if (!response) {
        throw new Error('Network response was not ok');
      }
      await fetchData(auditName, lote);
    } catch (error) {
      console.error("Error refining result:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleRollback = async (auditName, questionName, lote) => {
    setLoading(true);
    try {
      const response = await ResultsController.rollback(jwtToken, auditName, questionName, lote);
      if (!response) {
        throw new Error('Network response was not ok');
      }
      const response2 = await fetchData(auditName, lote);
      if (!response2) {
        throw new Error('Network response was not ok');
      }
    } catch (error) {
      console.error("Error rolling back result:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    fetchData(selectedAudit.name, selectedLote);
  };

  const handleAuditSelect = (e) => {
    const selectedName = e.target.value;
    const selectedAudit = audits.find(audit => audit.audit_name === selectedName);
    setSelectedAudit({ id: selectedAudit.audit_id, name: selectedAudit.audit_name });
    setSelectedLote('');
    fetchLotes(selectedAudit.audit_id);
  };

  const handleLoteSelect = (e) => {
    setSelectedLote(e.target.value);
  };

  useEffect(() => {
    fetchAudits();
  }, []);

  const handleFilterClick = (audit_id, lote) => {
    const url = `/admin/results?audit_name=${audit_id}&lote=${lote}`;
    history.push(url);
  };


  const handleEditClick = (response) => {
    setEditResponse({
      Id: response.id,
      resposta_resumida: response.resposta_resumida
    });
    setNewAnswer(response.resposta_resumida);
    setIsEditing(true);
  };

  const handleEditAnswer = async () => {
    if (!editResponse) return;

    try {
      await ResultsController.PutAnswer(editResponse.Id, newAnswer, jwtToken);
      await fetchData(selectedAudit.name, selectedLote);
      setIsEditing(false);
      setEditResponse(null);
      setNewAnswer('');
    } catch (error) {
      console.error("Error updating answer:", error);
    }
  };

  return (
    <Flex direction='column' height="100%" width="100%">
      <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
        <VStack align="stretch" spacing={4} p={5}>
          <HStack>
            <HStack spacing={4}>
              <Select
                placeholder="Selecionar ficha"
                value={selectedAudit.name}
                onChange={handleAuditSelect}
                width="200px"
              >
                {audits && audits.length > 0 && audits.map((audit, index) => (
                  <option key={index} value={audit?.audit_name}>
                    {audit?.audit_name}
                  </option>
                ))}
              </Select>
              <Select
                placeholder="Selecionar Lote"
                value={selectedLote}
                onChange={handleLoteSelect}
                width="300px"
                isDisabled={!selectedAudit.id}
              >
                {lotes && lotes.length > 0 && lotes.map((lote, index) => (
                  <option key={index} value={lote?.lote}>
                    {lote?.lote}
                  </option>
                ))}
              </Select>
            </HStack>
            <Button onClick={handleSearch} colorScheme="blue" width="auto" minWidth="200px">
              Buscar
            </Button>
          </HStack>

          {data.map((audit, index) => (
            <Flex direction='column' mb={3} key={index}>
              <Flex mb={2} fontSize="xl" fontWeight="bold" color={textColor}>
                Nome da Ficha: {audit.audit_name} - Lote: {audit.questions.length > 0 ? audit.questions[0].responses[0].lote : ''}
              </Flex>
              {audit.questions.map((question, qIndex) => (
                <Flex direction='column' mb={2} key={qIndex}>
                  <Flex mb={1} alignItems="center" justifyContent="space-between">
                    <Flex alignItems="center">
                      <Flex fontSize="lg" fontWeight="bold" color={textColor} mr={2}>
                        Pergunta: {question.user}
                      </Flex>
                      <Tooltip label={`Prompt: ${question.question_name}`} fontSize="md">
                        <span>
                          <Icon as={FaInfoCircle} />
                        </span>
                      </Tooltip>
                    </Flex>
                    <HStack>
                      <Button
                        size="sm"
                        colorScheme="blue"
                        onClick={() => handleRefinarResultado(audit.audit_name, question.question_name, audit.questions[0].responses[0].lote)}
                      >
                        Refinar Resultado
                      </Button>
                      <Button
                        size="sm"
                        colorScheme="blue"
                        onClick={() => handleRollback(audit.audit_name, question.question_name, audit.questions[0].responses[0].lote)}
                      >
                        Desfazer
                      </Button>
                    </HStack>
                  </Flex>
                  <Table variant='simple' color={textColor}>
                    <Thead>
                      <Tr>
                        <Th width="40%">Resposta Resumida</Th>
                        <Th textAlign="center" width="20%">Quantidade</Th>
                        <Th textAlign="center" width="20%">Porcentagem</Th>
                        <Th textAlign="center" width="20%">Ações</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {question.responses.map((response, rIndex) => (
                        <Tr key={rIndex}>
                          <Td p={1} width="40%">
                            <Flex align="center" mb={1}>
                              {response.resposta_resumida}
                            </Flex>
                          </Td>
                          <Td p={1} textAlign="center" width="20%">{response.count}</Td>
                          <Td p={1} textAlign="center" width="20%">{response.percentage.toFixed(2)}%</Td>
                          <Td p={1} textAlign="center" width="20%">
                            <HStack spacing={4} justifyContent="center">
                              <Tooltip label="Ver transcrições" fontSize="md">
                                <Button
                                  size="sm"
                                  colorScheme="gray"
                                  onClick={() => handleFilterClick(audit.audit_name, audit.questions[0].responses[0].lote)}
                                >
                                  <Icon as={FaEye} />
                                </Button>
                              </Tooltip>
                              <Tooltip label="Editar valor" fontSize="md">
                                <Button
                                  size="sm"
                                  colorScheme="gray"
                                  onClick={() => handleEditClick(response)}
                                >
                                  <Icon as={FaEdit} />
                                </Button>
                              </Tooltip>
                            </HStack>
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </Flex>
              ))}
              {index < data.length - 1 && <Divider mt={4} mb={4} />}
            </Flex>
          ))}
        </VStack>
      </Card>

      <Modal isOpen={isEditing} onClose={() => setIsEditing(false)}>
        <ModalContent>
          <ModalHeader>Editar resposta</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Input
              value={newAnswer}
              onChange={(e) => setNewAnswer(e.target.value)}
            />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={handleEditAnswer}>
              Salvar
            </Button>
            <Button ml={3} onClick={() => setIsEditing(false)}>
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
}

export default ResultsView;